import type { HTMLAttributes } from "react";

import type { TImageProps } from "@/ui/components/primitives/Image";
import type { DefinedDefaults } from "@/ui/lib";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const POLAROID_IMAGE_SIZE_CLASS_MAP = {
  default: "p-3",
  sm: "p-2",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TPolaroidImageSize = keyof typeof POLAROID_IMAGE_SIZE_CLASS_MAP;

export type TPolaroidImageProps = {
  image: TImageProps;
  rotation?: number;
  size?: TPolaroidImageSize;
} & HTMLAttributes<HTMLDivElement>;

type TPolaroidImageDefaults = DefinedDefaults<
  TPolaroidImageProps,
  "rotation" | "size"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const POLAROID_IMAGE_DEFAULTS = {
  rotation: -3,
  size: "default",
} satisfies TPolaroidImageDefaults;
